import { ApplicationContextServiceImpl } from "./context/application-context-service";
//import { msalAuthenticationDecorator } from "./adal-authentication-wrapper";
import { ClosePromptServiceImplementation } from "./closePromptService";
import { DeprecationService } from "./deprecationSvc";
import { DialogServiceImplementation } from "./dialog";
import { DisplayThemeServiceImpl } from "./display-theme-service";
import { PrerequisiteLoadingService, Prerequisite } from "./loading/prerequisite-loading-service";
import { DomainDataServiceImplementation } from "./domainDataSvc";
import { FlightingServiceImplementation } from "./flightingSvc";
import { JarvisServiceImplementation } from "./jarvisSvc";
import { LoggingServiceImplementation, LoggingSvcRun } from "./loggingSvc";
import { TelemetryServiceImplementation } from "../../ShellCommon/logger/telemetry-service";
import { PreferenceService } from "./preferenceSvc";
import {
  SignInReauthorizationServiceImpl,
  SignInReauthorizationRun,
  SignInReauthorizationService
} from "./signInReauthorizationService";
import { TelemetryReadytoSendService } from "./telemetry-ready-to-send-service";
import { TemplateServiceImplementation } from "./template-service";
import { UserTenantServiceImplementation } from "./user-tenant-service";
import { UserProfileServiceImplementation } from "./userProfile";
import { VisitServiceImplementation } from "./visitDataSvc";
import { ReleaseNotesService } from "./release-notes-config/release-notes-service";
import { ReleaseNotesConfigService } from "./release-notes-config/release-notes-config";
import { ReleaseNotesBundleService } from "./release-notes-bundle";
import { ChannelsService } from "./agent-channels/channels-service";
import { ChannelsConstants } from "./agent-channels/channels-constants";
import { MockDataService, MockResponseProvider, MockProvider } from "./mock/mock-data-service";
import { FeatureConfigService } from "./feature-config/feature-config";
import { StorageWrapperService } from "./local-storage-wrapper-service";
import { SettingsWindowService } from "./settings-window-service";
import { SdServicesSharedEnums } from "./sdServices-shared-enums";
import { FortificationServiceImplementation } from "./fortification";
import { RootStoreImplementation } from "./entity/entity-root-store-implementation";
import { ServiceDeskConfig } from "../Startup/serviceDeskConfig";
import { GraphApiServiceImplementation } from "./graph-api/graph-api-service";
import { MsalAuthenticationServiceImplementation } from "./msal/msal-authentication-service";

import app from "../sdAppModule";
import sdServicesModule from "./sdServicesModule";
import "./agent-action";
import "./asset-path-resolution";
import "./audit";
import "./authentication";
import "./authorization";
import "./availability-status";
import "./context";
import "./entity";
import "./entity-service-implementation";
import "./entity.v2";
import "./extensibility";
import "./loading";
import "./navigation";
import "./performance-logger";
import "./recovery";
import "./sd-controller";
import "./test-hook-service";

// @ngInject
app
  .service("applicationContextService", ApplicationContextServiceImpl)
  .config(["$httpProvider", function ($httpProvider: ng.IHttpProvider) {}]);
// @ngInject
sdServicesModule
  .constant("sdServicesSharedEnums", new SdServicesSharedEnums())
  .constant("channelsConstants", new ChannelsConstants())
  .constant("sdConfig", new ServiceDeskConfig())
  .service("fortificationService", FortificationServiceImplementation)
  .service("entityRootStore", RootStoreImplementation)
  .service("closePromptService", ClosePromptServiceImplementation)
  .service("deprecationService", DeprecationService)
  .service("dialogService", DialogServiceImplementation)
  .service("displayThemeService", DisplayThemeServiceImpl)
  .service("domainDataService", DomainDataServiceImplementation)
  .service("flightingService", FlightingServiceImplementation)
  .run((prerequisiteLoadingService: PrerequisiteLoadingService, flightingService: FlightingServiceImplementation) => {
    prerequisiteLoadingService.registerCallbackForPrerequisite("flightingService", (prerequisite: Prerequisite) => {
      return flightingService.prerequisiteLoadCallback(prerequisite);
    });
  })
  .service("jarvisService", JarvisServiceImplementation)
  .service("logViewService", LoggingServiceImplementation)
  .service("loggingService", LoggingServiceImplementation)
  .service("preferenceService", PreferenceService)
  .service("signInReauthorizationService", SignInReauthorizationServiceImpl)
  .service("telemetryReadytoSendService", TelemetryReadytoSendService)
  .service("templateService", TemplateServiceImplementation)
  .service("userTenantService", UserTenantServiceImplementation)
  .service("userProfileService", UserProfileServiceImplementation)
  .service("visitDataService", VisitServiceImplementation)
  .service("releaseNotesService", ReleaseNotesService)
  .service("releaseNotesConfigService", ReleaseNotesConfigService)
  .service("releaseNotesBundleService", ReleaseNotesBundleService)
  .service("mcMockDataService", MockDataService)
  .service("mcResponseProvider", MockResponseProvider)
  .service("mcProvider", MockProvider)
  .service("sdkChannelsService", ChannelsService)
  .service("featureConfigService", FeatureConfigService)
  .service("settingsWindowService", SettingsWindowService)
  .service("graphApiService", GraphApiServiceImplementation)
  .service("msalAuthenticationService", MsalAuthenticationServiceImplementation)
  // LocalStorage wrapper can be used outside of angular, adding a seperate registration
  .factory("StorageWrapperService", () => {
    return StorageWrapperService.getInstance();
  })
  .run((prerequisiteLoadingService: PrerequisiteLoadingService, preferenceService: PreferenceService) => {
    prerequisiteLoadingService.registerCallbackForPrerequisite("preferenceService", (prerequisite: Prerequisite) => {
      return preferenceService.prerequisiteLoadCallback(prerequisite);
    });
  })
  .run((prerequisiteLoadingService: PrerequisiteLoadingService, mcProvider: MockProvider) => {
    prerequisiteLoadingService.registerCallbackForPrerequisite("mcMockDataService", (prerequisite: Prerequisite) => {
      return mcProvider.prerequisiteLoadCallback(prerequisite);
    });
  })
  .run(
    (prerequisiteLoadingService: PrerequisiteLoadingService, releaseNotesBundleService: ReleaseNotesBundleService) => {
      prerequisiteLoadingService.registerCallbackForPrerequisite(
        "releaseNotesBundleService",
        (prerequisite: Prerequisite) => {
          return releaseNotesBundleService.prerequisiteLoadCallback(prerequisite);
        }
      );
    }
  )
  .run((prerequisiteLoadingService: PrerequisiteLoadingService, displayThemeService: DisplayThemeServiceImpl) => {
    prerequisiteLoadingService.registerCallbackForPrerequisite("displayThemeService", (prerequisite: Prerequisite) => {
      return displayThemeService.prerequisiteLoadCallback(prerequisite);
    });
  })
  .run((telemetryReadytoSendService: TelemetryReadytoSendService, $window: ng.IWindowService) => {
    $window.addEventListener("beforeunload", telemetryReadytoSendService.shutdown.bind(telemetryReadytoSendService));
  })
  .run(($rootScope: ng.IRootScopeService, signInReauthorizationService: SignInReauthorizationService) => {
    new SignInReauthorizationRun($rootScope, signInReauthorizationService);
  })
  .run(
    (
      $window: ng.IWindowService,
      loggingService: LoggingServiceImplementation,
      telemetryService: TelemetryServiceImplementation
    ) => {
      new LoggingSvcRun($window, loggingService, telemetryService);
    }
  );

export * from "./agent-action";
export * from "./asset-path-resolution";
export * from "./audit";
export * from "./authentication";
export * from "./authorization";
export * from "./availability-status";
export * from "./context";
export * from "./entity";
export * from "./entity-service-implementation";
export * from "./entity.v2";
export * from "./extensibility";
export * from "./fortification";
export * from "./loading";
export * from "./navigation";
export * from "./performance-logger";
export * from "./recovery";
export * from "./sd-controller";
export * from "./test-hook-service";
